import React from "react";
import { createRoot } from "react-dom/client";
import { bootstrapConfig, configBanner } from "./lib/config";
import { App } from "./App";

const ConfigBanner = () => {
  const b = configBanner.value;
  if (!b) return null;
  const palette = {
    error:   { bg: "#FDECEA", fg: "#8B1F1A", border: "#F4B7B1" },
    warning: { bg: "#FFF4D6", fg: "#6B4B00", border: "#F0D071" },
    info:    { bg: "#E7F1FE", fg: "#1A3F72", border: "#B5CEF2" },
  }[b.type] || { bg: "#FFF4D6", fg: "#6B4B00", border: "#F0D071" };
  return (
    <div style={{
      background: palette.bg, color: palette.fg, border: `1px solid ${palette.border}`,
      borderRadius: 8, padding: "10px 14px", margin: "12px 40px 0",
      fontSize: 14, fontFamily: "var(--font-sans)", maxWidth: 1240,
      marginLeft: "auto", marginRight: "auto",
    }}>
      <i className="ri-information-line" style={{ marginRight: 8 }} />
      {b.text}
    </div>
  );
};

(async () => {
  try {
    await bootstrapConfig();
  } catch (err) {
    console.error("[bootstrap] Config kon niet geladen worden", err);
    configBanner.value = {
      type: "error",
      text: "Configuratie kon niet geladen worden. Herlaad de pagina of neem contact op.",
    };
  }
  createRoot(document.getElementById("config-banner")).render(<ConfigBanner />);
  createRoot(document.getElementById("root")).render(<App />);
})();
